export const APPEL_LIST_REQUEST = "APPEL_LIST_REQUEST";
export const APPEL_LIST_SUCCESS = "APPEL_LIST_SUCCESS";
export const APPEL_LIST_FAIL = "APPEL_LIST_FAIL";
